"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillReason = void 0;
exports.reportRuleKey = reportRuleKey;
exports.exclusionReason = exclusionReason;
// The quality report's rule conditions (CR-002-SPEC §6.1–§6.5; CR2-064, CR2-065): per measure, in
// `REPORT_RULE_KEYS` order, the first rule whose condition holds names the patient's row. The
// conditions are code; the wording each rule shows is configuration (`report.rules`, D-1114). Pure:
// the inputs are a status, stratum codes, a quality code and a result, never a patient field.
const report_rules_js_1 = require("../config/report-rules.js");
const is = (status) => (input) => input.status === status;
const has = (input, stratum) => input.strata.includes(stratum);
const codeIs = (input, code) => code !== undefined && input.qualityCode === code;
/** Rules whose condition is the status alone, in every measure's table. */
const BY_STATUS = {
    excluded: is("EXCLUDED"),
    exception: is("EXCEPTION"),
    no_data: is("INCOMPLETE"),
};
/** Per measure, the rules with a condition beyond the status (§6.1–§6.5). */
const CONDITIONS = {
    "134": {
        met_negative: (i, c) => i.status === "MET" && codeIs(i, c.met_negative),
        met_positive_fu: (i, c) => i.status === "MET" && codeIs(i, c.met_positive_fu),
        met: is("MET"),
        positive_no_fu: (i, c) => i.status === "NOT_MET" && (codeIs(i, c.positive_no_fu) || has(i, "1b")),
        no_screening: is("NOT_MET"),
    },
    "001": {
        poor_gt9: (i, c) => i.status === "MET" &&
            (codeIs(i, c.poor_gt9) || has(i, "1a") || (i.resultValue !== null && i.resultValue > 9)),
        not_done: (i, c) => i.status === "MET" && (codeIs(i, c.not_done) || has(i, "1c")),
        poor: is("MET"),
        controlled_8_9: (i, c) => i.status === "NOT_MET" && (codeIs(i, c.controlled_8_9) || has(i, "1b")),
        controlled: is("NOT_MET"),
    },
    "236": {
        controlled: is("MET"),
        no_bp: (i, c) => i.status === "NOT_MET" && (codeIs(i, c.no_bp) || has(i, "1c")),
        uncontrolled: is("NOT_MET"),
    },
    "112": { screened: is("MET"), no_screening: is("NOT_MET") },
    "113": { screened: is("MET"), no_screening: is("NOT_MET") },
};
/** The key of the first rule of the measure's table that holds, or null for a measure without one. */
function reportRuleKey(measureNumber, input) {
    const keys = report_rules_js_1.REPORT_RULE_KEYS[measureNumber];
    if (keys === undefined)
        return null;
    const codes = report_rules_js_1.REPORT_RULE_CODES[measureNumber] ?? {};
    const own = CONDITIONS[measureNumber] ?? {};
    return keys.find((key) => (own[key] ?? BY_STATUS[key])?.(input, codes) ?? false) ?? null;
}
const REASON = /\{reason\}/g;
const DEFAULT_REASON = "Excluded";
/** CR2-065: the exclusion code's configured label, else the registry's status reason, else Excluded. */
function exclusionReason(exclusionLabels, exclusionCode, statusReason) {
    const label = exclusionCode === null ? undefined : exclusionLabels[exclusionCode];
    return label ?? (statusReason === null || statusReason === "" ? DEFAULT_REASON : statusReason);
}
/** A rule's configured text with `{reason}` filled. */
const fillReason = (text, reason) => text.replace(REASON, reason);
exports.fillReason = fillReason;
//# sourceMappingURL=rules.js.map